var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "errors-not-found-view"
  }, [_c('h1', [_vm._v("\n    " + _vm._s(_vm.$t('titles.notFound')) + "\n  ")]), _vm._v(" "), _c('alert-box', {
    attrs: {
      "type": "info",
      "icon": "info"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('hints.notFound')) + "\n  ")]), _vm._v(" "), (_vm.referrer) ? _c('link-button', {
    attrs: {
      "to": {
        path: _vm.referrer
      },
      "icon": "refresh"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('actions.retry')) + "\n  ")]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dc11539","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Errors/NotFoundView.vue
// module id = 2008
// module chunks = 0